// Posisi kapal di antara dua titik jejak.

function milidetik(point) {
  return Number(point && point.timestamp) * 1000;
}

function antara(a, b, t) {
  return a + (b - a) * t;
}

// Sudut lewat jalur terpendek: 350 -> 10 itu +20, bukan -340.
function antaraSudut(a, b, t) {
  const selisih = ((((b - a) % 360) + 540) % 360) - 180;
  return (((a + selisih * t) % 360) + 360) % 360;
}

function bentuk(point) {
  return {
    lat: point.latLong[0],
    lng: point.latLong[1],
    heading: Number(point.heading) || 0,
  };
}

// Indeks titik terakhir yang waktunya <= target.
function ruasSebelum(points, target) {
  let bawah = 0;
  let atas = points.length - 1;
  while (bawah < atas) {
    const tengah = Math.ceil((bawah + atas) / 2);
    if (milidetik(points[tengah]) <= target) bawah = tengah;
    else atas = tengah - 1;
  }
  return bawah;
}

export function timeRange(points) {
  if (!Array.isArray(points) || points.length < 2) return null;
  const start = milidetik(points[0]);
  const end = milidetik(points[points.length - 1]);
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return null;
  return { start, end };
}

export function positionAt(points, ms) {
  if (!Array.isArray(points) || points.length === 0) return null;
  const target = Number(ms);
  if (!Number.isFinite(target)) return null;

  const awal = milidetik(points[0]);
  const akhir = milidetik(points[points.length - 1]);
  if (!Number.isFinite(awal) || !Number.isFinite(akhir)) return null;
  if (target <= awal) return bentuk(points[0]);
  if (target >= akhir) return bentuk(points[points.length - 1]);

  const i = ruasSebelum(points, target);
  const a = points[i];
  const b = points[i + 1];
  if (!b) return bentuk(a);

  const rentang = milidetik(b) - milidetik(a);
  const t = rentang > 0 ? (target - milidetik(a)) / rentang : 0;
  return {
    lat: antara(a.latLong[0], b.latLong[0], t),
    lng: antara(a.latLong[1], b.latLong[1], t),
    heading: antaraSudut(Number(a.heading) || 0, Number(b.heading) || 0, t),
  };
}

export function pathUpTo(points, ms) {
  const posisi = positionAt(points, ms);
  if (!posisi) return [];
  const target = Number(ms);
  const jalur = points.filter((point) => milidetik(point) <= target).map((point) => point.latLong);
  if (!jalur.length) jalur.push(points[0].latLong);
  const ujung = jalur[jalur.length - 1];
  if (ujung[0] !== posisi.lat || ujung[1] !== posisi.lng) jalur.push([posisi.lat, posisi.lng]);
  return jalur;
}
